import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

export const Title = styled.h1`
  font-size: 4.8rem;
  line-height: 5.8rem;
  text-align: center;
  margin-bottom: 40px;
`;

export const Subtitle = styled.h2`
  font-size: 2.4rem;
  line-height: 2.9rem;
  text-align: center;
  color: ${p => p.theme.currentTheme.notes};
  margin-bottom: 60px;
`;
